import React from 'react'
import { useTranslation } from "react-i18next";

const ViewLabel = ({ field, moduleText, occupation = 6 }) => {
    const { t } = useTranslation();

    return (
        <div className={`col-md-${occupation}`}>
            <label 
            
            className="form-label tit-view-view subtitle-tit">
                {t(`${moduleText}.synthetic.${field}`)}
            </label>
        </div>
    )
}

export default ViewLabel